export const DEFAULT_LANGUAGE = "en";
export const SUPPORTED_LANGUAGES = ["en", "es_cl", "es_pe"];
export const ST_LANGUAGE_KEY = "service_tracker_lang";
export const ST_MARKET_CODE_KEY = "st_market_code";
export const ST_BRAND_ID_KEY = "st_brand_id";
